import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getOrders({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_ORDERS_REQUEST')

        return axios
            .get(`/orders/orders${paginate}${query}`)
            .then(response => {
                commit('GET_ORDERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_ORDERS_FAILURE')
                handleApiError(error, 'Pobranie listy zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrdersForShippingLabels({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_ORDERS_FOR_SHIPPING_LABELS_REQUEST')

        return axios
            .get(`/orders/orders-for-shipping-labels${paginate}${query}`)
            .then(response => {
                commit('GET_ORDERS_FOR_SHIPPING_LABELS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_ORDERS_FOR_SHIPPING_LABELS_FAILURE')
                handleApiError(error, 'Pobranie listy zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    findOrder(context, {productionNumber}) {
        return axios
            .get(`/orders/orders?productionNumber=${productionNumber}&limit=10`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Szukanie zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    findOrderRealizationReport(context, {productionNumber}) {
        return axios
            .get(`/orders/realization-report-orders?productionNumber=${productionNumber}&limit=10`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Szukanie zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrder(context, orderId) {
        return axios
            .get(`/orders/orders/${orderId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o zamówieniu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCountries() {
        return axios
            .get('/geolocalizations/geolocalizations/dicts/countries?isShippingToAllowed=true')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o możliwych krajach do wysyłki nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateDelivery(context, {id, payload}) {
        return axios
            .patch(`/deliveries/delivery/${id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja dostawy nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getToolboxTemplateContent(context, { toolboxURI, templateId }) {
        return axios
            .get(`${toolboxURI}/patern/${templateId}`, {
                transformRequest(data, headers) {
                    delete headers.common.Authorization

                    return data
                },
                headers: {
                    user: JSON.stringify({
                        name: 'test',
                        email: 'test',
                        production: true
                    })
                }
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Błąd komunikacji z Toolboxem.')

                return Promise.reject(error)
            })
    },
    addComment({ commit }, payload) {
        return axios
            .post('/orders/order-comments', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dodano komentarz.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie komentarza nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createOrder(context, orderData) {
        return axios
            .post('/orders/orders-collector', orderData)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Złożenie zamówienia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateOrder(context, payload) {
        return axios
            .patch(`/orders/orders-collector/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja zamówienia nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getOrdersProduct(_, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        return axios
            .get(`/orders/orders-product${paginate}${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie produktów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrderProduct(context, payload) {
        return axios
            .get(`/orders/orders-product/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie produktu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateOrderProduct(context, payload) {
        return axios
            .patch(`/orders/orders-product/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja produktu w zamówieniu nie powiodła się.')

                return Promise.reject(error)
            })
    },
    updateOrderProductComponent(context, payload) {
        return axios
            .patch(`/orders/orders-product-component/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja komponentu w zamówieniu nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getOrderStatuses({ commit }) {
        return axios
            .get('/orders/orders/dicts/statuses')
            .then(response => {
                commit('SET_ORDER_STATUS_LIST', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPrinters() {
        return axios
            .get('/print-manager/dicts/printers')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie drukarek nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCampaignOrdersToLink(context, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        return axios
            .get(`/orders/campaign-orders-to-link${paginate}${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie zamówień kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    printZPL(context, payload) {
        return axios
            .post('/sendings/print-existing-label', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wydrukowanie ZPL nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setEcommerceOrdersFilters({ commit }, filters) {
        commit('SET_ECOMMERCE_ORDERS_FILTERS', filters)
    },
    clearEcommerceOrdersFilters({ commit }) {
        commit('CLEAR_ECOMMERCE_ORDERS_FILTERS')
    },
    setInternalOrdersFilters({ commit }, filters) {
        commit('SET_INTERNAL_ORDERS_FILTERS', filters)
    },
    clearInternalOrdersFilters({ commit }) {
        commit('CLEAR_INTERNAL_ORDERS_FILTERS')
    },
    setNonStandardOrdersFilters({ commit }, filters) {
        commit('SET_NONSTANDARD_ORDERS_FILTERS', filters)
    },
    clearNonStandardOrdersFilters({ commit }) {
        commit('CLEAR_NONSTANDARD_ORDERS_FILTERS')
    }
}